import  './form-field-error.styles.scss';

const FormFieldError = ({errorMessage}) => (
    <div className="form-field-error">
        {errorMessage} 
    </div>
)

export default FormFieldError;